import { FC } from 'react'
import { useSelector } from 'react-redux'
import { ThunkType } from 'common/types'
import { Typography, TypographyVariants } from 'common/typography'
import { Modal } from 'features/Modal_V2'
import { ButtonType } from 'features/Modal_V2/ModalFooter'
import { selectOnboardingTranslations } from 'features/Translations/selectors'
import styles from './styles.module.sass'

interface IDiscardModal {
  isOpen: boolean
  onClose: () => void
  onDiscard: () => ThunkType | void,
  modalTitle?: string,
  modalSubtitle?: string,
  secondaryButtonText?: string,
  primaryButtonText?: string
}

export const DiscardModal: FC<IDiscardModal> = ({
  isOpen, onDiscard, onClose,
  modalTitle,
  modalSubtitle,
  secondaryButtonText,
  primaryButtonText
}) => {
  const onboardingTranslations = useSelector(selectOnboardingTranslations)

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      width={424}
      secondaryButtonText={secondaryButtonText || onboardingTranslations.cancelButtonText}
      primaryButtonText={primaryButtonText || onboardingTranslations.discardButtonText}
      secondaryButtonType={ButtonType.GHOST}
      primaryButtonType={ButtonType.SECONDARY}
      secondaryButtonOnClick={onClose}
      primaryButtonOnClick={() => {
        onClose()
        onDiscard()
      }}
      isNonClosable
    >
      <div className={styles.wrapper}>
        <Typography variant={TypographyVariants.Desktop_UI_XL_Medium} tag="p" className={styles.title}>
          {modalTitle || onboardingTranslations.discardChangesTitle}
        </Typography>
        <Typography variant={TypographyVariants.Desktop_UI_L_Regular} tag="p" className={styles.description}>
          {modalSubtitle || onboardingTranslations.discardChangesSubTitle}
        </Typography>
      </div>
    </Modal>
  )
}
